<template>
    <div>
        <modal v-model="treatmentModal" :title="titleTreatmentModal" @hide="resetTreatmentModal" size="lg">
            <div class="row">
                <div class="col-lg-2">
                    <div :class="[$v.treatment.code.required ? '' : 'has-error', 'form-group']">
                        <label class="control-label">Código</label>
                        <input type="text" class="form-control" v-model="treatment.code">
                    </div>
                </div>
                <div class="col-lg-8">
                    <div :class="[$v.treatment.procedure.required ? '' : 'has-error', 'form-group']">
                        <label class="control-label">Procedimento</label>
                        <input type="text" class="form-control" v-model="treatment.procedure">
                    </div>
                </div>
                <div class="col-lg-2">
                    <div class="form-group">
                        <label class="control-label">Valor</label>
                        <currency-input v-model="treatment.price" class="form-control" currency="BRL" :allow-negative="false" :auto-decimal-mode="true" :distraction-free="false"/>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-12">
                    <div :class="[$v.treatment.category_treatment_id.required ? '' : 'has-error', 'form-group']">
                        <label class="control-label">Categoria</label>
                        <div class="input-group">
                            <multiselect v-model="treatment.category_treatment_id" id="ajax" label="name" track-by="id" placeholder="Digite o nome ou o código da categoria desejada." open-direction="bottom"
                                        selectLabel="Enter para selecionar."
                                        deselectLabel="Enter para remover."
                                        :options="category_treatment_idOptions"
                                        :multiple="false"
                                        :searchable="true"
                                        :loading="isLoading"
                                        :preserve-search="true"
                                        :internal-search="false"
                                        :clear-on-select="true"
                                        :close-on-select="true"
                                        :max-height="450"
                                        :class="!$v.treatment.category_treatment_id.required ? 'invalid' : ''"
                                        :custom-label="codeWithNameLabel"
                                        :show-no-results="true" :hide-selected="false" @search-change="this.debouncedGetSearchCategories">
                                <span slot="noOptions">Digite o nome ou o código da categoria desejada.</span>
                                <span slot="noResult">Nenhum resultado encontrado.</span>
                            </multiselect>
                            <span class="input-group-btn">
                                <btn id="newCategoryButton" @click="addCategory" type="primary"><i class="fa fa-plus"></i></btn>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <btn @click="treatmentModal=false">Cancelar</btn>
                <btn type="primary" @click="saveTreatment"><i class="fa fa-save" aria-hidden="true"></i> {{okTextTreatmentModal}}</btn>
            </div>
            
            <modal v-model="categoryModal" title="Cadastrar nova categoria" append-to-body ref="modal2" @hide="resetCategoryModal">

                <div class="row">
                    <div class="col-lg-2">
                        <div :class="[$v.category_treatment.code.required ? '' : 'has-error', 'form-group']">
                            <label class="control-label">Código</label>
                            <input type="text" v-model="category_treatment.code" class="form-control">
                        </div>
                    </div>
                    <div class="col-lg-10">
                        <div :class="[$v.category_treatment.category_treatment.required ? '' : 'has-error', 'form-group']">
                            <label class="control-label">Categoria</label>
                            <input type="text" v-model="category_treatment.category_treatment" class="form-control">
                        </div>
                    </div>
                </div>

                <div slot="footer">
                    <btn @click="categoryModal=false">Cancelar</btn>
                    <btn type="primary" @click="saveCategory"><i class="fa fa-save" aria-hidden="true"></i> Cadastrar nova categoria</btn>
                </div>
            </modal>

        </modal>

        <modal v-model="batchAdjustmentModal" title="Reajustar todos os procedimentos" @hide="batchValue=0">
            <div>
                <p class="text-center">!! TODOS os procedimentos serão reajustados !!</p>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label class="control-label">Operação</label>
                            <select v-model="batchOperation" class="form-control">
                                <option value="-">Desconto</option>
                                <option value="+">Acréscimo</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div :class="[($v.batchValue.required && $v.batchValue.minValue) ? '' : 'has-error', 'form-group']">
                            <label class="control-label">Valor %</label>
                            <input v-model="batchValue" type="number" min="0" step="0.01" class="form-control">
                        </div>
                    </div>
                </div>
                </div>
            <div slot="footer">
                <btn @click="batchAdjustmentModal=false">Cancelar</btn>
                <btn type="primary" :disabled="!$v.batchValue.required && !$v.batchValue.minValue" @click="batchAdjustmentPriceTable"><i class="fa fa-plus" aria-hidden="true"></i> Aplicar reajuste em todos os procedimentos</btn>
            </div>
        </modal>


        <div class="panel panel-default">
            <div class="panel-heading">
                <div class="row" style="margin-bottom: -14px">
                    <div class='col-lg-12'>
                        <div class="form-group">
                            <btn type="info" @click="addTreatment"><i class="fa fa-plus" aria-hidden="true"></i> Novo Tratamento</btn>
                            <import-treatments-component class="pull-right"></import-treatments-component>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="box box-default">
                    <div class="box-header with-border">
                        <i class="fa fa-stethoscope"></i>
                        <h3 class="box-title">Tratamentos</h3>
                        <btn type="info" @click="batchAdjustmentModal = true" class="pull-right"> Ajuste em lote</btn>
                    </div>
                    <!-- /.box-header -->
                    <div class="box-body">
                        <datatable-component search-placeholder-prop="Buscar..." ref="dataTables" class="mt-3"
                                             :columns-prop="columns"
                                             url-prop="/treatments/simple/get/all"
                                             :tableDataSendRequestProp="{}"
                                             default-order-prop="code">
                            <template v-slot:category="data">
                                {{ (data.data.category.code ? data.data.category.code + ' | ' : '') + data.data.category.category_treatment }}
                            </template>
                            <template v-slot:action="data">
                                <li class="m-1" @click="editTreatment(data.data)"><a href="javascript:void(0)" title="Editar"><i class="fa fa-edit" aria-hidden="true"></i> Alterar</a></li>
                                <li class="m-1" @click="deleteTreatment(data.data)"><a href="javascript:void(0)" title="Excluir"><i class="fa fa-trash" aria-hidden="true"></i> Excluir</a></li>
                            </template>
                        </datatable-component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import DatatableComponent from "../datatable/datatable-component";
    import {required, minValue} from "vuelidate/lib/validators";
    import { CurrencyInput } from 'vue-currency-input'

    export default {
        name: "Treatments",
        components: { Multiselect, DatatableComponent },

        data() {
            return {
                isLoading: false,
                optionsToast: { timeout: 6000, position: 'topCenter' },
                treatmentModal: false,
                titleTreatmentModal: null,
                okTextTreatmentModal: null,
                categoryModal: false,
                batchAdjustmentModal: false,

                batchOperation: '-',
                batchValue: 0,

                category_treatment_idOptions: [],
                category_treatment: {
                    'id': null,
                    'code': null,
                    'category_treatment': null,
                },

                columns:[
                    { width: '5%', label: 'CÓDIGO.', name: 'code', sortable: true },
                    { width: '40%', label: 'PROCEDIMENTO', name: 'procedure', type: 'String', sortable: true },
                    { width: '37%', label: 'CATEGORIA', name: 'category', type: 'Slot', sortable: false },
                    { width: '13%', label: 'VALOR', name: 'price', type: 'Currency', sortable: true },
                    { width: '5%', label: 'AÇÃO', name: 'action', type: 'action', sortable: false },
                ],

                treatment: {
                    id: null,
                    code: null,
                    procedure: null,
                    price: 0,
                    category_treatment_id: null,
                }
            }
        },

        created() {
            // _.debounce é uma função fornecida pelo lodash para limitar a frequência que uma operação complexa pode ser executada.
            // Neste caso, queremos limitar a frequência com que acessamos a api, esperando que o usuário termine completamente
            // a digitação antes de realizar a chamada Ajax. Para aprender mais sobre a função _.debounce (e sua prima _.throttle),
            // visite: https://lodash.com/docs#debounce
            this.debouncedGetSearchCategories = _.debounce(this.searchCategories, 500)
        },

        validations: {
            treatment:{
                code: { required },
                procedure: { required },
                category_treatment_id:{required}
            },

            category_treatment:{
                code: { required },
                category_treatment: { required },
            },

            batchValue: {
                required, minValue: minValue(0.01)
            },

            validationGroupTreatment: ['treatment'],
            validationGroupCategoryTreatment: ['category_treatment'],
            validationGroupBatchValue: ['batchValue'],
        },

        methods: {
            resetTreatmentModal() {
                this.treatment = {
                    id: null,
                    code: null,
                    procedure: null,
                    price: 0,
                    category_treatment_id: null,
                }
            },

            addTreatment() {
                this.titleTreatmentModal = 'Cadastrar novo procedimento',
                    this.okTextTreatmentModal = 'Cadastrar novo procedimento',
                    this.treatmentModal = true
            },

            editTreatment(data) {
                Object.assign(this.treatment, data);
                console.log(data)
                this.treatment.category_treatment_id = data.category


                this.titlePriceListModal = 'Alterar procedimento'
                this.okTextTreatmentModal = 'Alterar procedimento'
                this.treatmentModal = true
            },

            async saveTreatment() {
                if (this.$v.validationGroupTreatment.$invalid) {
                    this.$toast.warning('Por favor revise os campos obrigatórios', 'Aviso', this.optionsToast);
                    return false
                }

                try {
                    this.treatmentModal = false
                    let response = {}
                    if (this.treatment.id)
                        response = await axios.put('/treatment/simple', this.treatment);
                    else
                        response = await axios.post('/treatment/simple', this.treatment);

                    if (response.data.type == 'success') {
                        this.$refs.dataTables.reload();
                        this.$toast.success(response.data.message, response.data.title, this.optionsToast);
                    } else if (response.data.type == 'warning') {
                        this.$toast.warning(response.data.message, response.data.title, this.optionsToast);
                    } else {
                        this.$toast.info(response.data.message, response.data.title, this.optionsToast);
                    }
                } catch (error) {
                    console.log(error);
                    if (error.response.status === 401 || error.response.status === 419) {
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                    } else {
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                }
            },

            deleteTreatment(data) {
                let self = this;
                this.$toast.question('Tem certeza que deseja excluir este procedimento?<br>Esta operação é irreversível!', 'ATENÇÃO', {
                    timeout: 20000,
                    close: false,
                    overlay: true,
                    toastOnce: true,
                    id: 'delete_' + data.id,
                    position: "center",
                    buttons: [
                        [
                            "<button><b>DELETAR PROCEDIMENTO</b></button>",
                            function (instance, toast) {
                                instance.hide({transitionOut: "fadeOut"}, toast);
                                axios.delete('/treatment/' + data.id)
                                    .then(response => {
                                        if (response.data.type == 'success') {
                                            self.$refs.dataTables.reload();
                                            self.$toast.success(response.data.message, response.data.title, self.optionsToast);
                                        } else if (response.data.type == 'warning') {
                                            self.$toast.warning(response.data.message, response.data.title, self.optionsToast);
                                        } else {
                                            self.$toast.info(response.data.message, response.data.title, self.optionsToast);
                                        }
                                    }).catch(error => {
                                    console.log(error);
                                    if (error.response.status === 401 || error.response.status === 419) {
                                        self.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', self.optionsToast);
                                    } else {
                                        self.$toast.error(error.response.data.message, 'Erro', self.optionsToast);
                                    }
                                })
                            },
                            true
                        ],
                        [
                            "<button>CANCELAR</button>",
                            function (instance, toast) {
                                instance.hide({transitionOut: "fadeOut"}, toast);
                            }
                        ]
                    ],
                })
            },

            addCategory(){
                this.categoryModal = true
            },

            resetCategoryModal() {
                this.category_treatment = {
                    'id': null,
                    'code': null,
                    'category_treatment': null,
                }
            },

            async saveCategory(){
                if (this.$v.validationGroupCategoryTreatment.$invalid) {
                    this.$toast.warning('Por favor revise os campos obrigatórios', 'Aviso', this.optionsToast);
                    return false
                }

                try {
                    this.categoryModal = false
                    const response = await axios.post('/category/treatment', this.category_treatment);
                    if (response.data.type == 'success') {
                        this.category_treatment_idOptions.push(response.data.category_treatment)
                        this.treatment.category_treatment_id = response.data.category_treatment
                        this.$toast.success(response.data.message, response.data.title, this.optionsToast);
                    } else if (response.data.type == 'warning') {
                        this.$toast.warning(response.data.message, response.data.title, this.optionsToast);
                    } else {
                        this.$toast.info(response.data.message, response.data.title, this.optionsToast);
                    }
                } catch (error) {
                    console.log(error);
                    if (error.response.status === 401 || error.response.status === 419) {
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                    } else {
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                }
            },

            async batchAdjustmentPriceTable() {
                if (this.$v.validationGroupBatchValue.$invalid) {
                    this.$toast.warning('O valor deve ser maior que zero', 'Aviso', this.optionsToast);
                    return false
                }

                try {
                    this.batchAdjustmentModal = false
                    const response = await axios.post('/treatment/batchAdjustment', {batchOperation:this.batchOperation, batchValue:this.batchValue});
                    if (response.data.type == 'success') {
                        this.$refs.dataTables.reload();
                        this.$toast.success(response.data.message, response.data.title, this.optionsToast);
                    } else if (response.data.type == 'warning') {
                        this.$toast.warning(response.data.message, response.data.title, this.optionsToast);
                    } else {
                        this.$toast.info(response.data.message, response.data.title, this.optionsToast);
                    }
                } catch (error) {
                    console.log(error);
                    if (error.response.status === 401 || error.response.status === 419) {
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                    } else {
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                }

            },

            codeWithNameLabel ({ code, category_treatment }) {
                return (code ? code + ' | ' : '') + category_treatment
            },

            searchCategories (query) {
                this.isLoading = true
                axios.post('/category/treatments/search', {'kw': query})
                    .then(function (response) {
                        this.category_treatment_idOptions = response.data
                        this.isLoading = false
                    }.bind(this))
                    .catch(function (error) {
                        console.log(error)
                    })
            },
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
    .invalid{
        padding: 0px;
        border: 1px solid #dd4b39;
        border-radius: 5px;
    }

    #newCategoryButton{
        height: 40px !important;
    }
</style>